export default __webpack_public_path__ + "static/x-1-97b015c682fb748e2159110c079fbf86.png";